import * as i0 from "@angular/core";
var IframeCommunicationService = /** @class */ (function () {
    function IframeCommunicationService() {
    }
    IframeCommunicationService.prototype.pageChange = function (url) {
        var _this = this;
        if (url === void 0) { url = 'changed'; }
        setTimeout(function () {
            var page = document.querySelector('.page');
            if (page)
                page.setAttribute('style', 'min-height: unset');
            var height = _this.getHeight();
            if (height)
                window.parent.postMessage({ changePage: url, height: height }, '*');
        }, 1000);
    };
    IframeCommunicationService.prototype.contentChangedScrollBottom = function () {
        var _this = this;
        setTimeout(function () {
            var height = _this.getHeight();
            if (height)
                window.parent.postMessage({ changePage: 1, scrollEnd: true, height: height }, '*');
        }, 500);
    };
    IframeCommunicationService.prototype.getHeight = function () {
        var el = document.body.querySelector('.ng-trigger div');
        return el ? el.scrollHeight : 0;
    };
    IframeCommunicationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IframeCommunicationService_Factory() { return new IframeCommunicationService(); }, token: IframeCommunicationService, providedIn: "root" });
    return IframeCommunicationService;
}());
export { IframeCommunicationService };
